// ── SCROLL REVEAL ──
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); revealObs.unobserve(e.target); } });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

// ── STICKY ADD TO CART ──
const stickyAtc = document.getElementById('sticky-atc');
const addToCartBtn = document.querySelector('.add-to-cart-btn');
if (stickyAtc && addToCartBtn) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) { stickyAtc.classList.add('visible'); }
      else { stickyAtc.classList.remove('visible'); }
    });
  }, { threshold: 0.1 });
  observer.observe(addToCartBtn);
}

// ── COUNTDOWN TIMER ──
const cdH = document.getElementById('cd-h');
const cdM = document.getElementById('cd-m');
const cdS = document.getElementById('cd-s');
if (cdH && cdM && cdS) {
  let key = 'aff_cd_end';
  let end = localStorage.getItem(key);
  if (!end) {
    end = Date.now() + (23 * 3600 + 59 * 60 + 59) * 1000;
    localStorage.setItem(key, end);
  }
  function updateCD() {
    let diff = Math.max(0, end - Date.now());
    let h = Math.floor(diff / 3600000);
    let m = Math.floor((diff % 3600000) / 60000);
    let s = Math.floor((diff % 60000) / 1000);
    cdH.textContent = String(h).padStart(2,'0');
    cdM.textContent = String(m).padStart(2,'0');
    cdS.textContent = String(s).padStart(2,'0');
    if (diff > 0) setTimeout(updateCD, 1000);
  }
  updateCD();
}

// ── EXIT INTENT ──
const exitPopup = document.getElementById('exit-popup');
const exitOverlay = document.getElementById('exit-overlay');
if (exitPopup && exitOverlay) {
  let shown = sessionStorage.getItem('exit_shown');
  if (!shown) {
    document.addEventListener('mouseleave', (e) => {
      if (e.clientY < 10 && !shown) {
        shown = true;
        sessionStorage.setItem('exit_shown', '1');
        exitPopup.style.display = 'block';
        exitOverlay.style.display = 'block';
      }
    });
    // Mobile: show after 40 seconds of inactivity
    let mobileTimer = setTimeout(() => {
      if (!shown && window.innerWidth < 768) {
        shown = true;
        sessionStorage.setItem('exit_shown', '1');
        exitPopup.style.display = 'block';
        exitOverlay.style.display = 'block';
      }
    }, 40000);
  }
}

// ── RECENTLY VIEWED ──
const rvSection = document.getElementById('recently-viewed');
const rvGrid = document.getElementById('rv-grid');
if (rvSection && rvGrid) {
  let viewed = JSON.parse(localStorage.getItem('aff_rv') || '[]');
  const currentHandle = window.location.pathname.split('/products/')[1];
  if (currentHandle) {
    viewed = viewed.filter(p => p.handle !== currentHandle);
    const productData = {
      handle: currentHandle,
      title: document.querySelector('.prod-title') ? document.querySelector('.prod-title').textContent : '',
      img: document.getElementById('main-product-img') ? document.getElementById('main-product-img').src : '',
      price: document.querySelector('.prod-price') ? document.querySelector('.prod-price').textContent : ''
    };
    viewed.unshift(productData);
    viewed = viewed.slice(0, 4);
    localStorage.setItem('aff_rv', JSON.stringify(viewed));
  }
  if (viewed.length > 0 && rvSection) {
    rvSection.style.display = 'block';
    viewed.forEach(p => {
      rvGrid.innerHTML += `<a href="/products/${p.handle}" class="also-card">
        <div class="also-img"><img src="${p.img}" alt="${p.title}" /></div>
        <h3>${p.title}</h3>
        <div class="also-price">${p.price}</div>
      </a>`;
    });
  }
}
